module.exports = __webpack_public_path__ + "static/media/2.3ac4d9e9.jpeg";